import { useCallback } from 'react';

import { BaseNotification } from 'components/UserNotification';
import {
  MappedLocalNotification,
  NotificationStatus,
  useUpdateLocalNotification,
} from 'utils/localNotifications';

type Props = {
  notification: MappedLocalNotification;
  dismisseable: boolean;
  onClick?: () => void;
};

export function LocalNotificationContent({
  notification,
  dismisseable,
  onClick,
}: Props) {
  const updateLocalNotification = useUpdateLocalNotification();

  const handleClick = useCallback(() => {
    updateLocalNotification(notification.type, {
      read: true,
    });
    onClick?.();
  }, [updateLocalNotification, notification, onClick]);

  const handleDismiss = useCallback(
    () =>
      updateLocalNotification(notification.type, {
        status: NotificationStatus.DISMISSED,
        read: true,
      }),
    [updateLocalNotification, notification],
  );

  return (
    <BaseNotification
      notification={notification}
      onClick={handleClick}
      onDismiss={dismisseable ? handleDismiss : undefined}
      qaId="notification"
    />
  );
}
